<script lang="ts">
    import { get } from 'svelte/store';
    import { onMount } from 'svelte';
    import { _ } from 'svelte-i18n';

    import { currentImport } from '../../shared/ColumnSelectPro/currentImport.js';
    import ProgressBar from '../../shared/ProgressBar.svelte';
    import { api } from '../../../stores/api';
    import { ImportApi } from './ImportApi';
    import { mainMenu } from '../../../stores/store';

    export let progressPercent: number = 0;
    export let error: string = '';
    export let autoHideWhenInactive: boolean = false;

    let intervalHandler: any = null;

    function checkImportStatus() {
        if ($currentImport !== null) {
            ImportApi.getStatus(get(api), $currentImport.id)
                .then(response => {
                    progressPercent = response.percent;
                    if (response.percent >= 100) {
                        // if ($currentImport !== null) {
                        //     ImportApi.updateJobs(get(api), $currentImport.id).then(res => {
                        //         console.log('update jobs', res);
                        //     });
                        // }
                        if ($currentImport.file_type === 'locations') {
                            $mainMenu.items.find(item => item.id === 'PageJobs').notification.reload = true;
                            $mainMenu = $mainMenu;
                        } else if ($currentImport.file_type === 'connections') {
                            $mainMenu.items.find(item => item.id === 'PageConnection').notification.reload = true;
                            $mainMenu = $mainMenu;
                        }
                        if (intervalHandler) clearInterval(intervalHandler);
                    }
                })
                .catch(err => {
                    if (intervalHandler) clearInterval(intervalHandler);
                    console.log(err);
                    error = String(err);
                });
        } else {
            // console.info('No import to check');
        }
    }

    onMount(() => {
        intervalHandler = setInterval(() => {
            checkImportStatus();
        }, 1000);

        return () => {
            if (intervalHandler) clearInterval(intervalHandler);
        };
    });

    // $: {
    //     isAnythingToLoad = $currentImport!==null;
    //     if (isAnythingToLoad && intervalHandler === null) {
    //         intervalHandler = setInterval( () => {
    //             checkImportStatus();
    //         }, 1000);
    //     }
    //
    // }
</script>

{#if autoHideWhenInactive && ($currentImport === null || progressPercent >= 100 || progressPercent <= 0)}
    <div class="hidden"></div>
{:else}
    <ProgressBar current={progressPercent} withShadow={false} label={$_('Geocoding')} />
{/if}
